import React from "react";
import WSHandler from "components/ws-handler";
import Updater from "./updater";
import ModalHandler from "./modal-handler";
import WsStatusesHandler from "components/WsStatusesHandler";
import WsRobotsUnreadHandler from "components/WsRobotsUnreadHandler/WsRobotsUnreadHandler";
import { useAppSelector } from "hooks/redux";
import NotificationSockets from "components/SideMenu/components/NotificationSockets";
import TickerBlocksSockets from "components/TickerBlocksSockets/TickerBlocksSockets";

const SideActionsHandler = () => {
    const selectetRobotId = useAppSelector(
        (state) => state.robots.selectedRobotId,
    );
    const { wsReadyStatuses } = useAppSelector(
        (state) => state.logs,
    );

    
    return (
        <>
            {selectetRobotId && (
                <>
                    <WSHandler />
                    <WsStatusesHandler />
                    <WsRobotsUnreadHandler />
                    <Updater />
                    <ModalHandler />
                    {wsReadyStatuses  && <NotificationSockets />}
                    {wsReadyStatuses && <TickerBlocksSockets />}
                </>
            )}
        </>
    );
};

export default SideActionsHandler;
